import React from 'react';
import {Draggable} from 'react-beautiful-dnd';
import {IsDraggingContext} from './DragDropTableBody';

const DraggableRow = (props) => {
    const {index, children} = props;

    return (
        <IsDraggingContext.Consumer key={`row-consumer-${index}`}>
            {(isDragging) => (
                <Draggable draggableId={`row-${index}`} index={index}>
                    {(provided, snapshot) => {
                        return <tr
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                            key={index}
                        >
                            {React.Children.map(children, (child) => React.cloneElement(child, {isDragging: isDragging}))}
                        </tr>;
                    }}
                </Draggable>
            )}
        </IsDraggingContext.Consumer>
    );
};

export default DraggableRow;
